import { AfterViewInit, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LineStatusRemoteDto } from '../../../../generated/signalR/line-status-remote-dto';
import { LineStatusType } from '../../../samwebDescription/samweb/contactStatus/lineStatusType';
import { LineStatusState } from '../../../store/samwin/contact-states/line-status/line-status.state';

@Component({
   selector: 'samweb-line-status',
   templateUrl: './line-status.component.html',
   styleUrls: ['./line-status.component.scss'],
})
export class LineStatusComponent implements AfterViewInit, OnDestroy, OnChanges {
   constructor(private store: Store) {}

   private destroy$ = new Subject();

   @Input()
   public fixedWidth: boolean;

   @Input()
   public tr87Number: string;
   @Input()
   public orgnum: string;

   public lineStatus$: Observable<{ lineStatus: LineStatusType; lineState: LineStatusRemoteDto }>;

   // Is needed for virtual scrolling, the data would not update correctly otherwise.
   ngOnChanges(changes: SimpleChanges): void {
      if (changes?.tr87Number?.previousValue !== changes?.tr87Number?.currentValue || changes?.orgnum?.previousValue !== changes?.orgnum?.currentValue) {
         this.ngAfterViewInit();
      }
   }

   ngAfterViewInit(): void {
      this.lineStatus$ = this.store.select(LineStatusState.getLineStateSelector(this.tr87Number, this.orgnum)).pipe(takeUntil(this.destroy$));
   }

   isForwardedAndIdle(lineStatus: LineStatusType, lineState: LineStatusRemoteDto): boolean {
      return lineState && !_.isEmpty(lineState.fwd) && lineStatus === LineStatusType.Idle;
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
